// Enum label maps shared across admin screens.

export const GENDER = {
  1: 'Woman',
  2: 'Man',
  3: 'Nonbinary',
};

export const SEXUALITY = {
  1: 'Prefer not to say',
  2: 'Straight',
  3: 'Gay',
  4: 'Lesbian',
  5: 'Bisexual',
  6: 'Allosexual',
  7: 'Androsexual',
  8: 'Asexual',
};

export const DATING_PREFERENCE = {
  1: 'Men',
  2: 'Women',
  3: 'Nonbinary People',
  4: 'Everyone',
};

export const HAVE_CHILDREN = {
  1: "Don't have children",
  2: 'Have children',
  3: 'Prefer not to say',
};

export const FAMILY_PLANS = {
  1: "Don't want children",
  2: 'Want children',
  3: 'Open to children',
  4: 'Not sure',
  5: 'Prefer not to say',
};

export const DATING_INTENTIONS = {
  1: 'Life partner',
  2: 'Long term relationship',
  3: 'Short term relationship',
  4: 'Figuring out my dating goals',
  5: 'Short term open to long',
};

export const HABIT = {
  1: 'Yes',
  2: 'No',
  3: 'Sometimes',
  4: 'Prefer not to say',
};

export const USER_ROLE = {
  1: 'Admin',
  2: 'User',
};

export const ACCOUNT_STATUS = {
  1: 'Applied',
  2: 'Joined',
};

export const IS_ACTIVE = {
  0: 'Inactive',
  1: 'Active',
};

export const IS_BLOCKED = {
  0: 'Not Blocked',
  1: 'Blocked',
};

export const REFERRAL_STATUS = {
  1: 'Pending',
  2: 'Completed',
};

export function enumLabel(map, value, fallback = '-') {
  if (value == null) return fallback;
  return map[value] ?? fallback;
}
